import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";

import useThemeService from "../../../../services/theme-service/ThemeService";
import {
  UploadSewerObjects,
  UploadSewerObjectsToProjectAssignedTo,
} from "../../../../services/authorization/Permissions";
import { Upload as UploadSvg } from "../../../../components/svg/svgImageList";
import Uploader from "../../../../components/upload-drop-files/Upload";
import Button from "../../../../components/button/Button";
import {
  uploadFilesService,
  UploadStatusOption,
} from "../../../../services/upload/UploadFilesService";
import { permissionsService } from "../../../../services/authorization/UserPermissionsService";
import { Dialog } from "../../../../components/dialog/Dialog";

interface Project {
  projectId: number;
  reloadSewerObjectsMap(): void;
}

export default observer(function UploadFileToProject({
  projectId,
  reloadSewerObjectsMap,
}: Project) {
  const { themeClass } = useThemeService();

  const startFilesUpload = useCallback(() => {
    uploadFilesService.startProjectUpload(projectId);
  }, [projectId]);

  const cancelFilesUpload = useCallback(() => {
    uploadFilesService.hideUploadModal();
    uploadFilesService.cancelUpload();
    uploadFilesService.setDefaultDataUpdateOption();
    uploadFilesService.setDefaultInspectionsRelevanceOption();
    uploadFilesService.setDefaultDataUpdateOption();
    uploadFilesService.setDefaultInspectionsRelevanceIntervalOption();
  }, []);

  useEffect(() => {
    if (uploadFilesService.uploadStatus === UploadStatusOption.completed) {
      reloadSewerObjectsMap();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadSewerObjectsMap, uploadFilesService.uploadStatus]);

  return (
    <div>
      <Button
        disabled={
          uploadFilesService.uploadStatus === UploadStatusOption.ongoing ||
          (!permissionsService.userHasPermissionTo(UploadSewerObjects) &&
            !permissionsService.userHasPermissionTo(UploadSewerObjectsToProjectAssignedTo))
        }
        id="button-upload"
        icon={{
          svg: UploadSvg,
          textKey: "general.upload.operation",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-upload"]),
        }}
        onClick={uploadFilesService.showUploadModal}
      />
      <Dialog
        isVisible={uploadFilesService.dropzoneIsVisible}
        sidePosition
        onHide={cancelFilesUpload}
        titleKey="general.upload.operation"
        buttonOk={{
          id: "start-file-upload",
          textKey: "general.upload.files",
          action: () => startFilesUpload(),
          disabled:
            uploadFilesService.filesForUpload.length === 0 ||
            uploadFilesService.isRemainingStorageLoading,
        }}
        buttonCancel={{
          textKey: "general.cancel",
          action: () => cancelFilesUpload(),
        }}
      >
        <Uploader />
      </Dialog>
    </div>
  );
});
